export const environment = {
  appVersion: '#{{VERSION}}#',
  production: true,
  //api:
  apiUrl: 'https://fd-slp-crb-cert-ekfzbrhggzbsercv.a01.azurefd.net/api',
  apiVersion: '1.0',
  appInsightsConnectionString: 'InstrumentationKey=a984be73-ab3c-426b-89f9-29f4fe868703;IngestionEndpoint=https://northcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://northcentralus.livediagnostics.monitor.azure.com/;ApplicationId=d41eab93-1d8a-4aeb-93fe-9cbb15868ec5',
  //Okta:
  clientId: '0oa6i7fv6iebbVlKj697',
  issuer: 'https://crb-dev-viewaccount.okta.com/oauth2/aus6kcm6qclXU2ZZF697',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,

  // Google Analytics
  measurementId: 'G-CNCR6MM6NW',

  //Space Chat
  spaceChat: 'https://d2kb4libjquh0y.cloudfront.net/scripts/ChatModule_c_u.js',
  spaceAuthenticatedChat: 'https://d2kb4libjquh0y.cloudfront.net/scripts/ChatModule_c_a.js',

  //Slider
  sliderDelay: 5000,
  //Aeropay legal documents
  aeropayTermsOfServiceUrl: 'https://www.aeropay.com/legal/terms-of-service---end-user',
  aeropayPrivacyPolicyUrl: 'https://www.aeropay.com/legal/privacy-policy',

  cRBTestDomain: '',
}
